export class MenuConfig {
	public defaults: any = {
		header: {
			self: {},
			items: [
				{
					title: 'MENU.DASHBOARD',
					root: true,
					alignment: 'left',
					page: '/app/dashboard',
					translate: 'MENU.DASHBOARD',
				},
				
				{
					title: 'MENU.STOKLAR',
					root: true,
					alignment: 'left',
					page: '/app/stock/list',
					translate: 'MENU.STOKLAR',
				},
				{
					title: 'MENU.TALEPLER',
					root: true,
					alignment: 'left',
					page: '/app/order/step1',
					translate: 'MENU.TALEPLER',
				},
				{
					title: 'MENU.RAPORLAR',
					root: true,
					alignment: 'left',
					page: '/app/report/menu',
					translate: 'MENU.RAPORLAR',
					// submenu: [
					// 	{
					// 		title: 'MENU.RAPORLAR.ALTDEPOSTOK',
					// 		page: '/app/report/items/1'
					// 	},
					// 	{
					// 		title: 'MENU.RAPORLAR.SKTRAPOR',
					// 		page: '/app/report/items/2'
					// 	},
					// 	{
					// 		title: 'MENU.RAPORLAR.HAREKETSIZLIK',
					// 		page: '/app/report/items/3'
					// 	},
					// 	{
					// 		title: 'MENU.RAPORLAR.URETICIGIRISLERI',
					// 		page: '/app/report/items/4'
					// 	},
					// 	{
					// 		title: 'MENU.RAPORLAR.HAREKET',
					// 		page: '/app/report/items/5'
					// 	},
					// 	{
					// 		title: 'Metabase Dashboard',
					// 		page: '/app/report/metabase'
					// 	}
					// ]
				},
				{
					title: 'MENU.ADMIN',
					root: true,
					alignment: 'left',
					page: '/app/admin',
					translate: 'MENU.ADMIN',
					submenu: [
						{
							title: 'MENU.ADMIN.USERS',
							page: '/app/admin/users',
						},
						
						{
							title: 'MENU.ADMIN.CUSTOMERS',
							page: '/app/admin/customers',
							
						},
						{
							title: 'MENU.ADMIN.TITLES',
							page: '/app/admin/titles',
							
						},
						{
							title: 'MENU.ADMIN.PAGES',
							page: '/app/admin/pages',
							
						},
						{
							title: 'MENU.ADMIN.WAREHOUSES',
							page: '/app/admin/warehouses',
							
						},
						
					]
				},
				{
					title: 'MENU.TEST',
					root: true,
					alignment: 'left',
					page: '/test/menu',
					translate: 'MENU.TEST',
					submenu: [
						{
							title: 'MENU.LOGIN',
							page: '/login'
						},
						{
							title: 'MENU.MENU',
							page: '/test/menu'
						},
						{
							title: 'MENU.USERS',
							page: '/test/users'
						},
						{
							title: 'Sub Test',
							page: '/test/subtest/mysubpage1'
						},
						{
							title: 'Admin Add User',
							page: '/app/admin/useradd'
						},
						
					]
				}
			]
		},
	
};

	public get configs(): any {
	return this.defaults;
	}
}
